class Audio {
    constructor() {
        // global class identifier
        this.class = {
            audioWrapper: '.audio_wrapper',
            audioText: '.js__audio-text',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * Two Click solution for YouTube Audio - Background-Image
     */
    audioPlaceholder() {
        if (document.querySelectorAll(this.class.audioWrapper).length > 0) {
            document.querySelectorAll(this.class.audioWrapper).forEach((wrapper) => {
                wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                    const trigger = e.currentTarget.parentElement;
                    trigger.closest('.audio-module').querySelector(this.class.audioText).classList.add('d-none');
                    trigger.classList.add('d-none');
                    trigger.nextElementSibling.classList.add('d-block');
                    trigger.nextElementSibling.querySelector('iframe').setAttribute('src', trigger.dataset.source);
                });
            });
        }
    }

    /**
     * Initialize Audio functions
     */
    init() {
        this.audioPlaceholder();
    }
}

export default new Audio();
